import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { END_POINTS_URL } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(private httpClient: HttpClient) { }

  uploadImage(file: any): Observable<any> {
    const URL = `${END_POINTS_URL.FILE_API.UPLOAD}`;
    return this.httpClient.post(URL, file, { responseType: 'text' });
  }
}
